import { Model } from 'app/model/backendmodel';
import { AdapterRegistry, Metamodel, IModel, ImportExportSettings, SnowflakeSource } from 'shell-models-lib';
import { Owned } from 'app/model/base/named';
import { ValueAdapter } from '../../value.adapter';
import { toParameterObject, toParameterClass } from '../../linkedservices/parameter-config.util';
import { CopySourceAdapter } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';

export const snowflakeSourceAdapter = {
    type: '*',
    query: '*',
    exportSettings: '*'
};
@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SnowflakeSource),
    asynchronous: true,
    adapts: snowflakeSourceAdapter,
    disabled: __IS_FABRIC_DPE__
})
export class SnowflakeSourceAdapter extends CopySourceAdapter<SnowflakeSource, Model.SnowflakeSource> {
    protected model(): IModel {
        return SnowflakeSource.MODEL;
    }

    protected override async _toResource(model: SnowflakeSource): Promise<Model.SnowflakeSource> {
        const result: Model.SnowflakeSource = this.getCommonCopySourceProperties(
            model,
            this.model().name
        );
        if (model.mode === 'query') {
            result.query = ValueAdapter.toResource(model, SnowflakeSource.READER_QUERY);
        }
        if (model.exportSettings != null) {
            result.exportSettings = {
                type: 'SnowflakeExportCopyCommand'
            };
            result.exportSettings.additionalCopyOptions = Array.isArray(model.exportSettings.additionalCopyOptions)
                ? toParameterObject(model.exportSettings.additionalCopyOptions)
                : ValueAdapter.toResource(model.exportSettings, ImportExportSettings.ADDITIONAL_COPYOPTIONS);
            result.exportSettings.additionalFormatOptions = Array.isArray(model.exportSettings.additionalFormatOptions)
                ? toParameterObject(model.exportSettings.additionalFormatOptions)
                : ValueAdapter.toResource(model.exportSettings, ImportExportSettings.ADDITIONAL_FORMATOPTIONS);
        }
        return result;
    }

    protected override async _toModel(resource: Model.SnowflakeSource, owner: CopyActivity): Promise<SnowflakeSource> {
        const result = this.createCopySourceWithCommonProperties(
            this.model(),
            resource,
            owner
        ) as SnowflakeSource;
        if (resource.query) {
            ValueAdapter.toModel(result, SnowflakeSource.READER_QUERY, resource.query);
            result.mode = 'query';
        }
        if (resource.exportSettings != null) {
            result.exportSettings = Owned.create<ImportExportSettings>(
                ImportExportSettings.MODEL,
                result
            );
            if (
                resource.exportSettings.additionalCopyOptions &&
                typeof resource.exportSettings.additionalCopyOptions === 'object' &&
                resource.exportSettings.additionalCopyOptions.type !== 'Expression'
            ) {
                result.exportSettings.additionalCopyOptions = toParameterClass(
                    resource.exportSettings.additionalCopyOptions,
                    result.exportSettings
                );
            } else {
                ValueAdapter.toModel(
                    result.exportSettings,
                    ImportExportSettings.ADDITIONAL_COPYOPTIONS,
                    resource.exportSettings.additionalCopyOptions
                );
            }
            if (
                resource.exportSettings.additionalFormatOptions &&
                typeof resource.exportSettings.additionalFormatOptions === 'object' &&
                resource.exportSettings.additionalFormatOptions.type !== 'Expression'
            ) {
                result.exportSettings.additionalFormatOptions = toParameterClass(
                    resource.exportSettings.additionalFormatOptions,
                    result.exportSettings
                );
            } else {
                ValueAdapter.toModel(
                    result.exportSettings,
                    ImportExportSettings.ADDITIONAL_FORMATOPTIONS,
                    resource.exportSettings.additionalFormatOptions
                );
            }
        }
        return result;
    }
}
